module.exports = __webpack_public_path__ + "img/1728525570274-IMG-20240328-WA0002 - Herlinawati.jpg.565ce67c.webp";